import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { FilterPopUpTable, ValueCheckbox } from 'app/shared/models/class/filterPopupTable/filterPopUpTable';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-admin-filter-table',
  templateUrl: './admin-filter-table.component.html',
  styleUrls: ['./admin-filter-table.component.scss']
})
export class AdminFilterTableComponent extends SubscriptionBaseComponent implements OnInit {
  @Input() idFilter: string;
  @Input() column: string;

  color: ThemePalette = 'primary';
  valuefilterSelected: FilterPopUpTable[];
  valueFilterChoice: string[] | ValueCheckbox[];

  constructor(
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private faIconService: FaiconService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.initSub();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  closePopup(): void {
    const popupFilter = document.getElementById(this.idFilter);
    popupFilter.style.display = 'none';
  }

  addOrDeleteFilter(value: any): void {

    if (this.valuefilterSelected?.length) {
      const indexLabel = this.valuefilterSelected.findIndex(label => label.column.toLocaleLowerCase() === this.column.toLocaleLowerCase());

      if (indexLabel !== -1) {
        this.valuefilterSelected.forEach((el, i) => {
          if (el.column.toLocaleLowerCase() === this.column.toLocaleLowerCase()) {
            const index = el.values.findIndex(v => {
              return isNaN(v) ? (v.toLocaleLowerCase() === value.toLocaleLowerCase()) : (v === value);
            });

            index === -1 ?
              el.values.push(isNaN(value) ? value.toLocaleLowerCase() : value) :
              el.values.splice(index, 1);

            if (el.values.length === 0) { this.valuefilterSelected.splice(i, 1); }
          }
        });

      } else {
        const label: FilterPopUpTable = {
          column: this.column,
          values: [value]
        };
        this.valuefilterSelected.push(label);
      }

    } else {
      const label: FilterPopUpTable = {
        column: this.column,
        values: [value]
      };

      this.valuefilterSelected.push(label);
    }

    this.dataService.valueFilterPopUpSelected$.next(this.valuefilterSelected);
  }

  resetSearch(): void {
    const index = this.valuefilterSelected.findIndex(el => el.column === this.column);
    if (index !== -1) { this.valuefilterSelected.splice(index, 1); }
    this.dataService.valueFilterPopUpSelected$.next(this.valuefilterSelected);
    const values = [];

    this.valueFilterChoice.forEach(v => { values.push(v.value); });
    this.dataService.valueFilterPopUpChoice$.next(values);
  }

  private convertValueCheckbox(values: string[]): ValueCheckbox[] {
    const valuesConvert: ValueCheckbox[] = [];
    const columnCheckBox = this.valuefilterSelected.find(el => el.column === this.column) || null;
    values.forEach(v => {
      const index = columnCheckBox ?
        columnCheckBox.values.findIndex(el => isNaN(el) ?
          el?.toLocaleLowerCase() === v?.toLocaleLowerCase() :
          el === v) :
        -1;
      const convert: ValueCheckbox = {
        value: v === undefined ? 'NC' : v,
        isCheck: index !== -1 ? true : false
      };
      valuesConvert.push(convert);
    });


    return valuesConvert;
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.valueFilterPopUpSelected$.subscribe({
          next: valueFilterSelected => {
            this.valuefilterSelected = valueFilterSelected;
            this.cdr.detectChanges();
          }
        })
      )
      .add(
        this.dataService.valueFilterPopUpChoice$.subscribe({
          next: valueFilterChoice => {
            this.valueFilterChoice = this.convertValueCheckbox(valueFilterChoice);
            this.cdr.detectChanges();
          }
        })
      );
  }
}
